import { useMemo } from 'react';
import { toggleAreaCheckbox } from '../useWizardState/wizard.state.actions';

const useWizardMenuItems = ({ wizardState }) => {
  const { projectAreas = [], teamAreas = [], selectedAreas = [] } = wizardState;

  const areasItems = useMemo(() => {
    const {
      teamAreas = [],
      projectAreas = [],
      selectedAreas = []
    } = wizardState;
    const teamAreasIds = teamAreas.map(team => team.id);
    const selectedAreasIds = selectedAreas.map(team => team.id);

    const areasList = projectAreas.map(area => {
      const isTeamArea = teamAreasIds.includes(area.id);
      const isSelected = isTeamArea || selectedAreasIds.includes(area.id);

      return {
        id: area.id,
        title: area.name,
        isSelected,
        disabled: isTeamArea,
        onClick: () => wizardState.dispatch(toggleAreaCheckbox(area))
      };
    });

    return areasList;
  }, [projectAreas, teamAreas, selectedAreas]);

  return {
    areasItems
  };
};

export default useWizardMenuItems;
